var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _circle8, _circle9, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect29, _rect30, _path20, _rect31, _rect32, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiredToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 261,
    viewBox: "0 0 375 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.199,
    y: 120.43,
    width: 45.3718,
    height: 139.57,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263.744,
    y: 164.59,
    width: 67.267,
    height: 95.4098,
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 318.704,
    y: 103.195,
    width: 42.8809,
    height: 156.805,
    fill: "#F7F7F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4722,
    y: 154.914,
    width: 35.4213,
    height: 105.086,
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.459,
    y: 98.6213,
    width: 35.4213,
    height: 161.379,
    fill: "#F7F7F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2939,
    y: 139.092,
    width: 19.7771,
    height: 51.0538,
    fill: "#F7F7F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9824,
    y: 116.702,
    width: 6.4012,
    height: 51.0538,
    fill: "#F7F7F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 173.277,
    y: 84.2366,
    width: 96.7744,
    height: 174.997,
    rx: 6,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.126 95.0061C177.126 91.6924 179.812 89.0061 183.126 89.0061H199.395C202.276 89.0061 201.662 92.7713 204.962 92.9361H210.53H221.664H232.799H238.366C241.305 92.9361 240.93 89.0061 243.934 89.0061H260.203C263.517 89.0061 266.203 91.6924 266.203 95.0061V248.465C266.203 251.778 263.517 254.465 260.203 254.465H183.126C179.812 254.465 177.126 251.778 177.126 248.465V95.0061Z",
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.193 98.9171C180.193 95.6034 182.88 92.9171 186.193 92.9171H201.508C204.265 92.9171 203.678 96.5793 206.836 96.7395H212.165H222.822H233.48H238.808C241.621 96.7395 241.261 92.9171 244.137 92.9171H259.451C262.765 92.9171 265.451 95.6034 265.451 98.9171V247.849C265.451 251.163 262.765 253.849 259.451 253.849H186.193C182.88 253.849 180.193 251.163 180.193 247.849V98.9171Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 270.052,
    y: 107.575,
    width: 3.11107,
    height: 9.47368,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 270.052,
    y: 127.552,
    width: 3.11107,
    height: 21.1354,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 85.2831,
    y: 161.881,
    width: 155.538,
    height: 97.3529,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4873,
    y: 180.53,
    width: 142.472,
    height: 78.3178,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1054,
    y: 202.092,
    width: 81.6154,
    height: 57.1423,
    fill: "#B0B0B0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 97.1428,
    y: 204.91,
    width: 76.346,
    height: 53.1052,
    fill: "#E2E2E2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 182.031,
    y: 202.092,
    width: 38.7995,
    height: 57.1423,
    fill: "#B0B0B0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 204.91,
    width: 34.8844,
    height: 53.2627,
    fill: "#E2E2E2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 99.569,
    y: 133.478,
    width: 116.665,
    height: 24.6861,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6512,
    y: 133.873,
    width: 112.478,
    height: 24.1619,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.807,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.949,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.092,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.378,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.52,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.092,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.235,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.234 185.477C216.234 189.422 219.329 192.62 223.146 192.62C224.711 192.62 226.154 192.082 227.313 191.176V179.778C226.154 178.872 224.711 178.334 223.146 178.334C219.329 178.334 216.234 181.532 216.234 185.477Z",
    fill: "#B0B0B0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.664,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.806,
    cy: 185.477,
    r: 7.14279,
    fill: "#B0B0B0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4261,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.568,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.711,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.997,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.139,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.712,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.854,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.996,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.283,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.425,
    cy: 180.867,
    rx: 7.14279,
    ry: 6.32868,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 85.2831,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 142.426,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 199.568,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 113.854,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 170.997,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5688,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 156.711,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 213.854,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 128.14,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 185.283,
    y: 161.881,
    width: 14.2856,
    height: 18.9861,
    fill: "#E2E2E2",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.604 139.544C127.605 140.322 126.203 137.356 124.816 136.228C124.217 135.741 123.416 135.315 122.259 135.315C121.579 135.315 121.365 134.463 119.052 136.228C114.481 139.716 109.855 136.513 108.918 133.857H138.144C138.144 135.929 135.725 139.059 132.604 139.544Z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.091 133.101V144.063L114.757 145.569V148.816H130.299V145.309L128.637 144.487V132.885C127.658 133.924 125.667 134.01 124.368 131.976C122.764 132.796 120.602 133.101 119.952 131.976C118.957 133.101 117.528 133.808 116.091 133.101Z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.867 151.407C119.677 149.283 121.941 152.281 122.351 153.543C120.604 154.659 120.431 155.983 118.178 156.163C115.924 156.342 112.248 155.211 109.242 150.934C110.529 152.046 114.058 153.532 116.867 151.407Z",
    fill: "#B0B0B0",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.889 151.407C127.08 149.283 124.816 152.281 124.406 153.543C126.153 154.659 126.325 155.983 128.579 156.163C130.833 156.342 134.508 155.211 137.514 150.934C136.227 152.046 132.698 153.532 129.889 151.407Z",
    fill: "#B0B0B0",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.223 138.277C125.224 139.055 123.822 136.089 122.435 134.961C121.836 134.474 121.035 134.048 119.878 134.048C119.198 134.048 118.984 133.196 116.671 134.961C112.1 138.449 107.484 134.451 106.547 131.796C105.817 129.726 105.577 125.078 109.228 122.281C112.879 119.485 123.558 120.504 127.89 126.836C134.666 124.281 135.888 129.724 135.888 131.796C135.888 133.868 133.344 137.792 130.223 138.277Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.71 131.835V142.797L112.377 144.302V147.549H127.918V144.043L126.256 143.22V131.618C125.277 132.657 123.286 132.744 121.987 130.709C120.383 131.53 118.221 131.835 117.572 130.709C116.576 131.835 115.147 132.542 113.71 131.835Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.486 150.141C117.295 148.016 119.56 151.014 119.97 152.276C118.223 153.392 118.05 154.717 115.796 154.896C113.543 155.075 109.867 153.944 106.861 149.667C108.148 150.78 111.677 152.265 114.486 150.141Z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.508 150.141C124.699 148.016 122.435 151.014 122.025 152.276C123.772 153.392 123.944 154.717 126.198 154.896C128.451 155.075 132.127 153.944 135.133 149.667C133.846 150.78 130.317 152.265 127.508 150.141Z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.3426,
    cy: 251.238,
    r: 7.25248,
    fill: "#B0B0B0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.319,
    cy: 251.238,
    r: 7.25248,
    fill: "#B0B0B0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.4008,
    cy: 250.589,
    r: 5.74155,
    fill: "#E0E0E0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.734,
    cy: 250.589,
    r: 5.74155,
    fill: "#E0E0E0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.3426,
    cy: 251.238,
    r: 6.25248,
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.319,
    cy: 251.238,
    r: 6.25248,
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.586 207.118V250.936H132.379C132.22 246.069 128.224 242.172 123.319 242.172C118.413 242.172 114.417 246.069 114.258 250.936H80.4032C80.2438 246.069 76.2482 242.172 71.3425 242.172C66.4368 242.172 62.4412 246.069 62.2818 250.936H51.7003V238.848L65.6008 218.299H81.9189V207.118H142.586Z",
    fill: "#BDBDBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.586 250.936V251.936C143.138 251.936 143.586 251.488 143.586 250.936H142.586ZM142.586 207.118H143.586C143.586 206.566 143.138 206.118 142.586 206.118V207.118ZM132.379 250.936L131.38 250.968C131.398 251.508 131.84 251.936 132.379 251.936V250.936ZM114.258 250.936V251.936C114.798 251.936 115.24 251.508 115.257 250.968L114.258 250.936ZM80.4032 250.936L79.4037 250.968C79.4214 251.508 79.8636 251.936 80.4032 251.936V250.936ZM62.2818 250.936V251.936C62.8214 251.936 63.2636 251.508 63.2813 250.968L62.2818 250.936ZM51.7003 250.936H50.7003C50.7003 251.488 51.148 251.936 51.7003 251.936V250.936ZM51.7003 238.848L50.872 238.288C50.7601 238.453 50.7003 238.648 50.7003 238.848H51.7003ZM65.6008 218.299V217.299C65.2689 217.299 64.9586 217.464 64.7726 217.739L65.6008 218.299ZM81.9189 218.299V219.299C82.4712 219.299 82.9189 218.852 82.9189 218.299H81.9189ZM81.9189 207.118V206.118C81.3667 206.118 80.9189 206.566 80.9189 207.118H81.9189ZM143.586 250.936V207.118H141.586V250.936H143.586ZM132.379 251.936H142.586V249.936H132.379V251.936ZM123.319 243.172C127.683 243.172 131.238 246.639 131.38 250.968L133.379 250.903C133.202 245.498 128.766 241.172 123.319 241.172V243.172ZM115.257 250.968C115.399 246.639 118.954 243.172 123.319 243.172V241.172C117.872 241.172 113.435 245.498 113.259 250.903L115.257 250.968ZM80.4032 251.936H114.258V249.936H80.4032V251.936ZM71.3425 243.172C75.7069 243.172 79.262 246.639 79.4037 250.968L81.4026 250.903C81.2257 245.498 76.7895 241.172 71.3425 241.172V243.172ZM63.2813 250.968C63.423 246.639 66.9781 243.172 71.3425 243.172V241.172C65.8955 241.172 61.4593 245.498 61.2824 250.903L63.2813 250.968ZM51.7003 251.936H62.2818V249.936H51.7003V251.936ZM50.7003 238.848V250.936H52.7003V238.848H50.7003ZM64.7726 217.739L50.872 238.288L52.5285 239.408L66.4291 218.86L64.7726 217.739ZM81.9189 217.299H65.6008V219.299H81.9189V217.299ZM80.9189 207.118V218.299H82.9189V207.118H80.9189ZM142.586 206.118H81.9189V208.118H142.586V206.118Z",
    fill: "#4F4F4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.823 207.118V250.936H132.379C132.22 246.069 128.224 242.172 123.319 242.172C118.413 242.172 114.417 246.069 114.258 250.936H80.4032C80.2438 246.069 76.2482 242.172 71.3425 242.172C66.4368 242.172 62.4412 246.069 62.2818 250.936H51.7003V238.848L65.6008 218.299H81.9189V207.118H137.823Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.823 250.936V251.936C138.376 251.936 138.823 251.488 138.823 250.936H137.823ZM137.823 207.118H138.823C138.823 206.566 138.376 206.118 137.823 206.118V207.118ZM132.379 250.936L131.38 250.968C131.398 251.508 131.84 251.936 132.379 251.936V250.936ZM114.258 250.936V251.936C114.798 251.936 115.24 251.508 115.257 250.968L114.258 250.936ZM80.4032 250.936L79.4037 250.968C79.4214 251.508 79.8636 251.936 80.4032 251.936V250.936ZM62.2818 250.936V251.936C62.8214 251.936 63.2636 251.508 63.2813 250.968L62.2818 250.936ZM51.7003 250.936H50.7003C50.7003 251.488 51.148 251.936 51.7003 251.936V250.936ZM51.7003 238.848L50.872 238.288C50.7601 238.453 50.7003 238.648 50.7003 238.848H51.7003ZM65.6008 218.299V217.299C65.2689 217.299 64.9586 217.464 64.7726 217.739L65.6008 218.299ZM81.9189 218.299V219.299C82.4712 219.299 82.9189 218.852 82.9189 218.299H81.9189ZM81.9189 207.118V206.118C81.3666 206.118 80.9189 206.566 80.9189 207.118H81.9189ZM138.823 250.936V207.118H136.823V250.936H138.823ZM132.379 251.936H137.823V249.936H132.379V251.936ZM123.319 243.172C127.683 243.172 131.238 246.639 131.38 250.968L133.379 250.903C133.202 245.498 128.766 241.172 123.319 241.172V243.172ZM115.257 250.968C115.399 246.639 118.954 243.172 123.319 243.172V241.172C117.872 241.172 113.435 245.498 113.259 250.903L115.257 250.968ZM80.4032 251.936H114.258V249.936H80.4032V251.936ZM71.3425 243.172C75.7069 243.172 79.262 246.639 79.4037 250.968L81.4026 250.903C81.2257 245.498 76.7895 241.172 71.3425 241.172V243.172ZM63.2813 250.968C63.423 246.639 66.9781 243.172 71.3425 243.172V241.172C65.8955 241.172 61.4593 245.498 61.2824 250.903L63.2813 250.968ZM51.7003 251.936H62.2818V249.936H51.7003V251.936ZM50.7003 238.848V250.936H52.7003V238.848H50.7003ZM64.7726 217.739L50.872 238.288L52.5285 239.408L66.4291 218.86L64.7726 217.739ZM81.9189 217.299H65.6008V219.299H81.9189V217.299ZM80.9189 207.118V218.299H82.9189V207.118H80.9189ZM137.823 206.118H81.9189V208.118H137.823V206.118Z",
    fill: "#4F4F4F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.919 237.337H137.824V240.359H84.0458L81.919 237.337Z",
    fill: "#B0B0B0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.919 218.602V237.337H137.824",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3424 221.291L71.3424 237.646",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.823 250.936V251.936C138.376 251.936 138.823 251.488 138.823 250.936H137.823ZM137.823 207.118H138.823C138.823 206.566 138.376 206.118 137.823 206.118V207.118ZM132.379 250.936L131.38 250.968C131.398 251.508 131.84 251.936 132.379 251.936V250.936ZM114.258 250.936V251.936C114.798 251.936 115.24 251.508 115.257 250.968L114.258 250.936ZM80.4032 250.936L79.4037 250.968C79.4214 251.508 79.8636 251.936 80.4032 251.936V250.936ZM62.2818 250.936V251.936C62.8214 251.936 63.2636 251.508 63.2813 250.968L62.2818 250.936ZM51.7003 250.936H50.7003C50.7003 251.488 51.148 251.936 51.7003 251.936V250.936ZM51.7003 238.848L50.872 238.288C50.7601 238.453 50.7003 238.648 50.7003 238.848H51.7003ZM65.6008 218.299V217.299C65.2689 217.299 64.9586 217.464 64.7726 217.739L65.6008 218.299ZM81.9189 218.299V219.299C82.4712 219.299 82.9189 218.852 82.9189 218.299H81.9189ZM81.9189 207.118V206.118C81.3666 206.118 80.9189 206.566 80.9189 207.118H81.9189ZM138.823 250.936V207.118H136.823V250.936H138.823ZM132.379 251.936H137.823V249.936H132.379V251.936ZM123.319 243.172C127.683 243.172 131.238 246.639 131.38 250.968L133.379 250.903C133.202 245.498 128.766 241.172 123.319 241.172V243.172ZM115.257 250.968C115.399 246.639 118.954 243.172 123.319 243.172V241.172C117.872 241.172 113.435 245.498 113.259 250.903L115.257 250.968ZM80.4032 251.936H114.258V249.936H80.4032V251.936ZM71.3425 243.172C75.7069 243.172 79.262 246.639 79.4037 250.968L81.4026 250.903C81.2257 245.498 76.7895 241.172 71.3425 241.172V243.172ZM63.2813 250.968C63.423 246.639 66.9781 243.172 71.3425 243.172V241.172C65.8955 241.172 61.4593 245.498 61.2824 250.903L63.2813 250.968ZM51.7003 251.936H62.2818V249.936H51.7003V251.936ZM50.7003 238.848V250.936H52.7003V238.848H50.7003ZM64.7726 217.739L50.872 238.288L52.5285 239.408L66.4291 218.86L64.7726 217.739ZM81.9189 217.299H65.6008V219.299H81.9189V217.299ZM80.9189 207.118V218.299H82.9189V207.118H80.9189ZM137.823 206.118H81.9189V208.118H137.823V206.118Z",
    fill: "#4A4A4A"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 302.452,
    y: 185.202,
    width: 38.6923,
    height: 56.4336,
    rx: 10,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 303.452,
    y: 186.202,
    width: 34.4628,
    height: 51.1262,
    rx: 9,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M321.946 240.636L321.946 259.39",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 285.638,
    y: 205.384,
    width: 28.5743,
    height: 41.4233,
    rx: 10,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 286.638,
    y: 206.384,
    width: 24.9596,
    height: 37.0279,
    rx: 9,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M300.032 245.808L300.032 259.391",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 259.234L375 259.234M27 259.234H18M12 259.234H8.5",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredToken);
export default __webpack_public_path__ + "static/media/expiredToken.6ecffddf62e3cedfa8d80d73417fe52c.svg";
export { ForwardRef as ReactComponent };